<div class="login_content">
	<router-outlet></router-outlet>
</div>



// WEBPACK FOOTER //
// ./src/app/layouts/login-layout/login-layout.component.html